import { productImageMap } from "./productImages";
import educationKitRedPad from "@/assets/products/education-kit-red-pad.png";
import educationKitBluePad from "@/assets/products/education-kit-blue-pad.png";
import educationKitGreenSquare from "@/assets/products/education-kit-green-square.png";
import educationKitBlackSquare from "@/assets/products/education-kit-black-square.png";
import educationKitBlackPad from "@/assets/products/education-kit-black-pad.png";
import educationKitGreenPad from "@/assets/products/education-kit-green-pad.png";
import satpinYellowBoard from "@/assets/products/satpin-yellow-board.png";
import satpinRedPad from "@/assets/products/satpin-red-pad.png";
import agriSensoryPadBlue from "@/assets/products/agri-sensory-pad-blue.png";
import agriSensoryPadGreen from "@/assets/products/agri-sensory-pad-green.png";
import rockLibrarySquare from "@/assets/products/rock-library-square.jpg";
import rockLibrarySquareGreen from "@/assets/products/rock-library-square-green.jpg";
import set3RockLibrarySquareBlack from "@/assets/products/set-3-rock-library-square-black.jpg";
import set3RockLibrarySquareWhite from "@/assets/products/set-3-rock-library-square-white.jpg";
import textureLibrarySquareGreen1 from "@/assets/products/texture-library-square-green-1.png";
import textureLibrarySquareGreen2 from "@/assets/products/texture-library-square-green-2.png";
import unicornLibrarySquare from "@/assets/products/unicorn-library-square.jpg";
import unicornLibrarySquareWhite from "@/assets/products/unicorn-library-square-white.png";
import unicornLibrarySquareWhiteSet from "@/assets/products/set-3-unicorn-library-square-white.png";
import unicornLibrarySquareBlackSet from "@/assets/products/set-3-unicorn-library-square-black.png";
import pointsLibrarySquare from "@/assets/products/points-library-square.jpg";
import set3PointsLibrarySquareBlack from "@/assets/products/set-3-points-library-square-black.jpg";
import librarySquareWhiteSet from "@/assets/products/library-square-white-set.jpg";
import agriYellowSquares from "@/assets/products/agri-yellow-squares.png";

export type Product = {
  name: string;
  slug: string;
  description: string;
  badge?: string;
  price: number;
  image?: {
    src: string;
    alt: string;
  };
  images?: Array<{
    src: string;
    alt: string;
  }>;
  features?: string[];
  outOfStock?: boolean;
  placement?: 'shop' | 'teams' | 'both';
};

export const products: Product[] = [
  {
    name: "Education Kit school up to 1500",
    slug: "/product/education-kit-school-1500",
    description: "60 Sensory Pads (30 Red and 30 Blue), and 300 Sensory Libraries (75 each Rock and Points in Black and Green).",
    price: 3500.00,
    image: {
      src: productImageMap["/product/education-kit-school-1500"],
      alt: "Education Kit for schools up to 1500 students"
    },
    images: [
      {
        src: educationKitRedPad,
        alt: "Red sensory pad – main view"
      },
      {
        src: educationKitBluePad,
        alt: "Blue sensory pad – secondary view"
      },
      {
        src: educationKitBlackPad,
        alt: "Black sensory pad with textured dots"
      },
      {
        src: educationKitGreenPad,
        alt: "Green sensory pad with textured dots"
      },
      {
        src: educationKitGreenSquare,
        alt: "Green library squares – included in kit"
      },
      {
        src: educationKitBlackSquare,
        alt: "Black texture square – included in kit"
      }
    ],
    features: [
      "60 sensory pads included",
      "300 library squares",
      "Multiple texture varieties",
      "Ideal for large schools",
      "Bulk educational pricing"
    ]
  },
  {
    name: "Education Kit school up to 1000",
    slug: "/product/education-kit-school-1000",
    description: "20 Sensory Pads (10 Red and 10 Blue), and 200 Sensory Libraries (50 each Rock and Points in Black and Green).",
    price: 1500.00,
    image: {
      src: productImageMap["/product/education-kit-school-1000"],
      alt: "Education Kit for schools up to 1000 students"
    },
    images: [
      {
        src: educationKitRedPad,
        alt: "Red sensory pad – main view"
      },
      {
        src: educationKitBluePad,
        alt: "Blue sensory pad – secondary view"
      },
      {
        src: educationKitBlackPad,
        alt: "Black sensory pad with textured dots"
      },
      {
        src: educationKitGreenPad,
        alt: "Green sensory pad with textured dots"
      },
      {
        src: educationKitGreenSquare,
        alt: "Green library squares – included in kit"
      },
      {
        src: educationKitBlackSquare,
        alt: "Black texture square – included in kit"
      }
    ],
    features: [
      "20 sensory pads included",
      "200 library squares",
      "Cost-effective bundle",
      "Perfect for medium schools",
      "Mix of textures & colours"
    ]
  },
  {
    name: "Education Kit school up to 500",
    slug: "/product/education-kit-school-500",
    description: "12 Sensory Pads (6 Red and 6 Blue), and 100 Sensory Libraries (25 each Rock and Points in Black and Green).",
    price: 900.00,
    image: {
      src: productImageMap["/product/education-kit-school-500"],
      alt: "Education Kit for schools up to 500 students"
    },
    images: [
      {
        src: educationKitRedPad,
        alt: "Red sensory pad – main view"
      },
      {
        src: educationKitBluePad,
        alt: "Blue sensory pad – secondary view"
      },
      {
        src: educationKitBlackPad,
        alt: "Black sensory pad with textured dots"
      },
      {
        src: educationKitGreenPad,
        alt: "Green sensory pad with textured dots"
      },
      {
        src: educationKitGreenSquare,
        alt: "Green library squares – included in kit"
      },
      {
        src: educationKitBlackSquare,
        alt: "Black texture square – included in kit"
      }
    ],
  },
  {
    name: "Education Kit school up to 250",
    slug: "/product/education-kit-school-250",
    description: "8 Sensory Pads (4 Red and 4 Blue), and 40 Sensory Libraries (20 each Rock and Points in Black and Green).",
    price: 610.00,
    image: {
      src: productImageMap["/product/education-kit-school-250"],
      alt: "Education Kit for schools up to 250 students"
    },
    images: [
      {
        src: educationKitRedPad,
        alt: "Red sensory pad – main view"
      },
      {
        src: educationKitBluePad,
        alt: "Blue sensory pad – secondary view"
      },
      {
        src: educationKitBlackPad,
        alt: "Black sensory pad with textured dots"
      },
      {
        src: educationKitGreenPad,
        alt: "Green sensory pad with textured dots"
      },
      {
        src: educationKitGreenSquare,
        alt: "Green library squares – included in kit"
      },
      {
        src: educationKitBlackSquare,
        alt: "Black texture square – included in kit"
      }
    ],
  },
  {
    name: "Access to Work Kit",
    slug: "/access-to-work-kits",
    description: "We have now this access to work kit or work kit which has three pads in and 10 sensory libraries so you can have a pad and sensory libraries at work and at home office and one to use that required",
    price: 240.00,
    placement: 'teams',
    image: {
      src: productImageMap["/access-to-work-kits"],
      alt: "Access to Work sensory kit"
    },
    features: [
      "3 sensory pads included",
      "10 library squares",
      "Work, home & travel set",
      "Workplace support",
      "Government scheme eligible"
    ]
  },
  {
    name: "Set Of 3 Points Library Square – Colour White",
    slug: "/product/set-3-points-library-square-white",
    description: "Our sensory library squares offer a variety of textures to suit different sensory feedback levels. You might prefer different textures based on your needs and moods. With frequent use, your sense of touch will improve in both your skin and brain, making even gentle textures more stimulating.",
    price: 12.95,
    image: {
      src: productImageMap["/product/set-3-points-library-square-white"],
      alt: "Set of 3 points library squares in white"
    },
    images: [
      {
        src: librarySquareWhiteSet,
        alt: "Points library square in white"
      },
      {
        src: set3PointsLibrarySquareBlack,
        alt: "Points library square in black"
      }
    ],
  },
  {
    name: "Set Of 3 Points Library Square – Colour Black",
    slug: "/product/set-3-points-library-square-black",
    description: "Our sensory library squares offer a variety of textures to suit different sensory feedback levels. You might prefer different textures based on your needs and moods. With frequent use, your sense of touch will improve in both your skin and brain, making even gentle textures more stimulating.",
    price: 12.95,
    image: {
      src: productImageMap["/product/set-3-points-library-square-black"],
      alt: "Set of 3 points library squares in black"
    },
    images: [
      {
        src: librarySquareWhiteSet,
        alt: "Points library square in white"
      },
      {
        src: set3PointsLibrarySquareBlack,
        alt: "Points library square in black"
      }
    ],
  },
  {
    name: "Set Of 3 Rock Library Square – Colour White",
    slug: "/product/set-3-rock-library-square-white",
    description: "Our sensory library squares offer a variety of textures to suit different sensory feedback levels. You might prefer different textures based on your needs and moods. With frequent use, your sense of touch will improve in both your skin and brain, making even gentle textures more stimulating.",
    price: 12.95,
    image: {
      src: productImageMap["/product/set-3-rock-library-square-white"],
      alt: "Set of 3 rock library squares in white"
    },
    images: [
      {
        src: set3RockLibrarySquareBlack,
        alt: "Rock library square in black"
      },
      {
        src: set3RockLibrarySquareWhite,
        alt: "Rock library square in white"
      },
      {
        src: rockLibrarySquareGreen,
        alt: "Rock library square in green"
      }
    ],
  },
  {
    name: "Set Of 3 Rock Library Square – Colour Black",
    slug: "/product/set-3-rock-library-square-black",
    description: "Our sensory library squares offer a variety of textures to suit different sensory feedback levels. You might prefer different textures based on your needs and moods. With frequent use, your sense of touch will improve in both your skin and brain, making even gentle textures more stimulating.",
    price: 12.95,
    image: {
      src: productImageMap["/product/set-3-rock-library-square-black"],
      alt: "Set of 3 rock library squares in black"
    },
    images: [
      {
        src: set3RockLibrarySquareBlack,
        alt: "Rock library square in black"
      },
      {
        src: set3RockLibrarySquareWhite,
        alt: "Rock library square in white"
      },
      {
        src: rockLibrarySquareGreen,
        alt: "Rock library square in green"
      }
    ],
  },
  {
    name: "Set Of 3 Unicorn Library Square – Colour White",
    slug: "/product/set-3-unicorn-library-square-white",
    description: "Our sensory library squares offer a variety of textures to suit different sensory feedback levels. You might prefer different textures based on your needs and moods. With frequent use, your sense of touch will improve in both your skin and brain, making even gentle textures more stimulating.",
    price: 12.95,
    image: {
      src: productImageMap["/product/set-3-unicorn-library-square-white"],
      alt: "Set of 3 unicorn library squares in white"
    },
    images: [
      {
        src: unicornLibrarySquareWhiteSet,
        alt: "Unicorn library square in white"
      },
      {
        src: unicornLibrarySquareBlackSet,
        alt: "Unicorn library square in black"
      }
    ],
  },
  {
    name: "Set Of 3 Unicorn Library Square – Colour Black",
    slug: "/product/set-3-unicorn-library-square-black",
    description: "Our sensory library squares offer a variety of textures to suit different sensory feedback levels. You might prefer different textures based on your needs and moods. With frequent use, your sense of touch will improve in both your skin and brain, making even gentle textures more stimulating.",
    price: 12.95,
    image: {
      src: productImageMap["/product/set-3-unicorn-library-square-black"],
      alt: "Set of 3 unicorn library squares in black"
    },
    images: [
      {
        src: unicornLibrarySquareWhiteSet,
        alt: "Unicorn library square in white"
      },
      {
        src: unicornLibrarySquareBlackSet,
        alt: "Unicorn library square in black"
      }
    ],
  },
  {
    name: "Unicorn Library Square",
    slug: "/product/unicorn-library-square",
    description: "Our sensory library squares offer a variety of textures to suit different sensory feedback levels. You might prefer different textures based on your needs and moods. With frequent use, your sense of touch will improve in both your skin and brain, making even gentle textures more stimulating.",
    price: 5.75,
    image: {
      src: productImageMap["/product/unicorn-library-square"],
      alt: "Unicorn library square sensory tile"
    },
    images: [
      {
        src: unicornLibrarySquareWhite,
        alt: "Unicorn library square in white"
      },
      {
        src: unicornLibrarySquare,
        alt: "Unicorn library square in black"
      }
    ],
  },
  {
    name: "Points Library Square",
    slug: "/product/points-library-square",
    description: "Our sensory library squares offer a variety of textures to suit different sensory feedback levels. You might prefer different textures based on your needs and moods. With frequent use, your sense of touch will improve in both your skin and brain, making even gentle textures more stimulating.",
    price: 5.75,
    image: {
      src: productImageMap["/product/points-library-square"],
      alt: "Points library square sensory tile"
    },
    images: [
      {
        src: librarySquareWhiteSet,
        alt: "Points library square in white"
      },
      {
        src: pointsLibrarySquare,
        alt: "Points library square in black"
      }
    ],
  },
  {
    name: "Rock Library Square",
    slug: "/product/rock-library-square",
    description: "Our sensory library squares offer a variety of textures to suit different sensory feedback levels. You might prefer different textures based on your needs and moods. With frequent use, your sense of touch will improve in both your skin and brain, making even gentle textures more stimulating.",
    price: 5.75,
    image: {
      src: productImageMap["/product/rock-library-square"],
      alt: "Rock library square sensory tile"
    },
    images: [
      {
        src: rockLibrarySquare,
        alt: "Rock library square in black"
      },
      {
        src: set3RockLibrarySquareWhite,
        alt: "Rock library square in white"
      },
      {
        src: rockLibrarySquareGreen,
        alt: "Rock library square in green"
      }
    ],
  },
  {
    name: "Texture Library Square",
    slug: "/product/texture-library-square",
    description: "Our sensory library squares offer a variety of textures to suit different sensory feedback levels. You might prefer different textures based on your needs and moods. With frequent use, your sense of touch will improve in both your skin and brain, making even gentle textures more stimulating.",
    price: 5.75,
    image: {
      src: textureLibrarySquareGreen1,
      alt: "Texture library square sensory tile"
    },
    images: [
      {
        src: textureLibrarySquareGreen1,
        alt: "Texture library square – main view"
      },
      {
        src: textureLibrarySquareGreen2,
        alt: "Texture library square – detailed texture view"
      }
    ],
  },
  {
    name: "Rock Library Square – Colour Green",
    slug: "/product/rock-library-square-green",
    description: "Our sensory library squares offer a variety of textures to suit different sensory feedback levels. You might prefer different textures based on your needs and moods. With frequent use, your sense of touch will improve in both your skin and brain, making even gentle textures more stimulating.",
    price: 5.75,
    image: {
      src: productImageMap["/product/rock-library-square-green"],
      alt: "Rock library square in green"
    },
    images: [
      {
        src: rockLibrarySquare,
        alt: "Rock library square in black"
      },
      {
        src: set3RockLibrarySquareWhite,
        alt: "Rock library square in white"
      },
      {
        src: rockLibrarySquareGreen,
        alt: "Rock library square in green"
      }
    ],
  },
  {
    name: "Agri Biodegradable Plastic Points Library Square – Yellow",
    slug: "/product/agri-points-library-square-yellow",
    description: "Our sensory library squares offer a variety of textures to suit different sensory feedback levels. You might prefer different textures based on your needs and moods. With frequent use, your sense of touch will improve in both your skin and brain, making even gentle textures more stimulating.",
    badge: "Eco-Friendly",
    price: 5.75,
    image: {
      src: productImageMap["/product/agri-points-library-square-yellow"],
      alt: "Agri biodegradable points library square in yellow"
    },
    images: [
      {
        src: agriYellowSquares,
        alt: "Agri points library square in yellow"
      }
    ],
  },
  {
    name: "Agri Biodegradable Plastic Texture Library Square – Yellow",
    slug: "/product/agri-texture-library-square",
    description: "Our sensory library squares offer a variety of textures to suit different sensory feedback levels. You might prefer different textures based on your needs and moods. With frequent use, your sense of touch will improve in both your skin and brain, making even gentle textures more stimulating.",
    badge: "Eco-Friendly",
    price: 5.75,
    image: {
      src: productImageMap["/product/agri-texture-library-square"],
      alt: "Agri biodegradable texture library square"
    },
    images: [
      {
        src: agriYellowSquares,
        alt: "Agri texture library square in yellow"
      }
    ],
  },
  {
    name: "Set Of 2 Agri Biodegradable Plastic Library Square – Colour Yellow",
    slug: "/product/set-2-agri-library-squares-yellow",
    description: "Our sensory library squares offer a variety of textures to suit different sensory feedback levels. You might prefer different textures based on your needs and moods. With frequent use, your sense of touch will improve in both your skin and brain, making even gentle textures more stimulating.",
    badge: "Eco-Friendly",
    price: 10.00,
    image: {
      src: productImageMap["/product/set-2-agri-library-squares-yellow"],
      alt: "Set of 2 agri library squares in yellow"
    },
    images: [
      {
        src: agriYellowSquares,
        alt: "Agri library squares in yellow"
      }
    ],
  },
  {
    name: "Samboards Sensory Pads – Large",
    slug: "/product/samboards-sensory-pads-large",
    description: "Introducing our Sensory Pads, designed to provide a range of textures for individuals dealing with sensory issues and living with dementia. The A5 size pad features a variety of textures, each creating a different feel, offering a tactile and stimulating experience. Available in vibrant colours such as Orange, Red, and Yellow, these pads are perfect for sensory stimulation and relaxation therapy. Whether used by individuals in need of sensory input or by caregivers working with those living with dementia, our Sensory Pads offer a versatile and effective solution for promoting health and wellbeing.",
    price: 72.99,
    placement: 'both',
    image: {
      src: productImageMap["/product/samboards-sensory-pads-large"],
      alt: "Large Samboards sensory pad"
    },
  },
  {
    name: "Agri Biodegradable Plastic Sensory Pads",
    slug: "/product/agri-biodegradable-plastic-sensory-pads",
    description: "Introducing our Agri Biodegradable Plastic Sensory Pads, designed in Gloucestershire for eco-conscious sensory seekers. The pads come in a calming blue and green color scheme, perfect for creating a soothing sensory environment. Made from biodegradable plastic, these pads are not only gentle on the environment but also provide tactile and visual stimulation for users. Measuring A5 in size, these pads are perfect for on-the-go sensory support, whether at home, school, or in the office. Add these eco-friendly sensory pads to your collection and enjoy the benefits of sustainable, tactile stimulation.",
    badge: "Eco-Friendly",
    price: 72.99,
    placement: 'both',
    image: {
      src: agriSensoryPadBlue,
      alt: "Agri biodegradable plastic sensory pad in blue"
    },
    images: [
      {
        src: agriSensoryPadBlue,
        alt: "Blue agri sensory pad – main view"
      },
      {
        src: agriSensoryPadGreen,
        alt: "Green agri sensory pad – alternate view"
      }
    ],
  },
  {
    name: "Set Of 5 Agri Biodegradable Plastic Sensory Pads",
    slug: "/product/set-5-agri-sensory-pads",
    description: "Introducing our Sensory Pads, designed to provide a range of textures for individuals dealing with sensory issues and living with dementia. The A5 size pad features a variety of textures, each creating a different feel, offering a tactile and stimulating experience. Available in vibrant colours such as Orange, Red, and Yellow, these pads are perfect for sensory stimulation and relaxation therapy. Whether used by individuals in need of sensory input or by caregivers working with those living with dementia, our Sensory Pads offer a versatile and effective solution for promoting health and wellbeing.",
    badge: "Eco-Friendly",
    price: 300.00,
    outOfStock: true,
    image: {
      src: productImageMap["/product/set-5-agri-sensory-pads"],
      alt: "Set of 5 agri biodegradable sensory pads"
    },
  },
  {
    name: "Satpin Board",
    slug: "/satpin",
    description: "Educational sensory learning tool for early literacy.",
    price: 350.00,
    placement: 'both',
    image: {
      src: productImageMap["/satpin"],
      alt: "Satpin Board sensory learning tool"
    },
    images: [
      {
        src: satpinYellowBoard,
        alt: "Satpin Board yellow sensory textures – main view"
      },
      {
        src: satpinRedPad,
        alt: "Red sensory pad – included accessory"
      }
    ],
  },
  {
    name: "Samboards Lanyard",
    slug: "/product/samboards-lanyard",
    description: "Discover the Official Samboards Ltd lanyard, designed to seamlessly integrate with our sensory products for unparalleled convenience. Crafted to support your sensory-activated motor skills development, this lanyard allows you to keep essential sensory tools within easy reach throughout your day. Proudly developed in the UK, Samboards Ltd prioritises your health and wellness, providing quality accessories that enhance your daily routine.",
    price: 1.50,
    image: {
      src: productImageMap["/product/samboards-lanyard"],
      alt: "Samboards lanyard with branding"
    },
  },
];
